// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__SzXIU","code":"notFound_code__IPGUj","message":"notFound_message__2QT0m"};